!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={279:(e,t,r)=>{r.d(t,{Button:()=>d,ButtonText:()=>c,ButtonUnderline:()=>b,ButtonsContainer:()=>s,Tab:()=>a,TabBar:()=>l});const o=require("styled-components");var n=r.n(o);const a=n().div.attrs({role:"tabpanel",tabIndex:-1})``,i=o.css`
  #${e=>e["aria-activedescendant"]} {
    outline: var(--outline);
    outline-offset: -2px;
    z-index: 10;
    background: var(--color-overlay-hover-darken);
    > span {
      color: var(--color-primary-variant);
    }
  }
`,l=n().div`
  display: flex;
  flex-direction: column;
  outline: none;
  position: relative;
  height: 44px;

  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;

  scrollbar-width: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
  &::-webkit-scrollbar {
    /* WebKit */
    width: 0;
    height: 0;
  }

  border-bottom: 1px solid var(--color-border);

  &:focus-visible {
    ${i}
  }
  ${({isUsingKeyboard:e})=>e&&o.css`
      &:focus,
      &:focus-within {
        ${i}
      }
    `}

  &::-moz-focus-inner {
    border: 0;
  }
`,s=n().div`
  display: flex;
  flex-wrap: nowrap;
`,c=n().span`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  padding: 12px 16px;

  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;

  &::-moz-focus-inner {
    border: 0;
  }

  color: ${e=>e.active?"var(--color-primary)":"var(--color-inactive)"};

  white-space: nowrap;

  @media (max-width: 768) {
    font-size: 14px;
  }
`,d=n().button`
  box-sizing: border-box;

  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  color: var(--color-on-background);

  :hover {
    background: var(--color-overlay-hover-darken);
  }

  :hover ${c} {
    color: var(--color-primaryVariant);
  }

  :active {
    background: var(--color-overlay-hover-pressed);
  }

  :focus-visible {
    outline: none;
  }
  &[aria-disabled='true'] {
    cursor: not-allowed;

    :hover ${c} {
      color: var(--color-disabled);
    }

    ${c} {
      color: var(--color-disabled);
    }
  }
`,b=n().span`
  background-color: var(--color-primary);
  height: 4px;
  width: ${({width:e})=>`${e}px`};
  z-index: 1;
  bottom: 0px;
  transform-origin: left center 0px;
  position: absolute;
  transition:
    transform 200ms ease-in-out,
    width 200ms ease-in-out;
  transform: ${({x:e})=>`translateX(${e}px)`};
`}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var a=t[o]={exports:{}};return e[o](a,a.exports,r),a.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{r.r(o),r.d(o,{Tab:()=>n.Tab,TabBar:()=>n.TabBar,Tabs:()=>c,default:()=>d});const e=require("react");var t=r.n(e),n=r(279),a=function(e,t){var r={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(r[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&Object.prototype.propertyIsEnumerable.call(e,o[n])&&(r[o[n]]=e[o[n]])}return r};const i=(e,t)=>e>0?e-1:t-1,l=(e,t)=>e<t-1?e+1:0,s=e=>{var t;return null===(t=document.getElementById(`tab-${e}`))||void 0===t?void 0:t.scrollIntoView({behavior:"smooth",inline:"nearest"})};function c(r){var{children:o,activeTabId:c=o.flat()[0].props.id,description:d,onChange:b,className:u}=r,p=a(r,["children","activeTabId","description","onChange","className"]);const[f,v]=(0,e.useState)(c),[m,h]=(0,e.useState)(c),[x,y]=(0,e.useState)({width:0,x:0}),g=o.flat(),w=t().Children.map(g,(e=>e.props.id)),k=w.indexOf(f),O=w.indexOf(m),[$,E]=(0,e.useState)(!1);(0,e.useEffect)((()=>{const e=()=>E(!1);return window.addEventListener("click",e),()=>{window.removeEventListener("click",e)}}),[]),(0,e.useEffect)((()=>{v(c)}),[c]);const T=(e,t)=>{"true"!==e.currentTarget.getAttribute("aria-disabled")&&(v(t),h(t),b&&b(e,t))};return t().createElement("div",Object.assign({className:`tabs ${u}`},p),t().createElement(n.TabBar,{role:"tablist","aria-activedescendant":`tab-${m}`,"aria-label":d,onKeyDown:e=>function(e){switch(e.key){case"Enter":case" ":e.preventDefault(),E(!0),g[O].props.disabled||T(e,m);break;case"End":e.preventDefault(),E(!0),h(w[w.length-1]),s(w[w.length-1]);break;case"Home":e.preventDefault(),E(!0),h(w[0]),s(w[0]);break;case"Left":case"ArrowLeft":e.preventDefault(),E(!0),(()=>{const e=i(O,w.length);h(w[e]),s(w[e])})();break;case"Right":case"ArrowRight":e.preventDefault(),E(!0),(()=>{const e=l(O,w.length);h(w[e]),s(w[e])})()}}(e),tabIndex:0,isUsingKeyboard:$},t().createElement(n.ButtonsContainer,null,t().Children.map(g,(({props:{id:e,label:r,trackid:o,disabled:a}})=>{const i=f===e;return t().createElement(n.Button,{role:"tab","aria-selected":i,"aria-controls":e,onClick:t=>T(t,e),id:`tab-${e}`,tabIndex:-1,type:"button","data-trackid":o,"aria-disabled":a},t().createElement(n.ButtonText,{active:i,ref:t=>{t&&e===f&&(e=>x.width!==(null==e?void 0:e.offsetWidth)||x.x!==e.offsetLeft)(t)&&y({width:t.offsetWidth,x:t.offsetLeft})}},r))}))),t().createElement("div",null,t().createElement(n.ButtonUnderline,Object.assign({"data-chromatic":"ignore"},x)))),g[k])}const d=c})(),o})()));
//# sourceMappingURL=index.js.map